var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_vm._v(" "+_vm._s(_vm.msg)+" "),_c('button',[_vm._v("123")])])
}
var staticRenderFns = []

export { render, staticRenderFns }